import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Card, CardBody, CardHeader, Col, InputGroup, Row} from "reactstrap";
import {FormattedMessage} from "react-intl";
import InputNumber from "components/InputNumber";

class CollectorResponses extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.data
    };
  }

  onChange(property, value){
    this.setState({
      data: {
        ...this.state.data,
        [property]: value
      }
    }, () => {
      this.props.onChange(property, this.state.data[property])
    });
  }

  render() {
    const {errors} = this.props;
    const {data} = this.state;

    return (
      <Col className="d-flex align-items-md-stretch" xs={this.props.xs} lg={this.props.lg}>
        <Card className="w-100">
          <CardHeader className="text-center"><FormattedMessage tagName="h2" id="formDefaultProperty.label.collectorResponses" /></CardHeader>
          <hr className="my-0"/>
          <CardBody>
            <InputNumber min={0} step={10} disabled={this.props.disabled} value={data.collectorResponses} onChange={collectorResponses => this.onChange('collectorResponses', collectorResponses)} className={"collector-input" + (this.props.disabled ? " not-active" : "")}/>
            {errors.collectorResponses && <div className="invalid-feedback d-block mt-0">{errors.collectorResponses.join(<br />)}</div>}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

CollectorResponses.defaultProps = {
  disabled: false,
  errors: {},
  xs: 12,
  lg: 4,
};

CollectorResponses.propTypes = {
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    startAt: PropTypes.string,
    endAt: PropTypes.string,
  }).isRequired,
  errors: PropTypes.object.isRequired,
  xs: PropTypes.oneOf([1,2,3,4,5,6,7,8,9,10,11,12]).isRequired,
  lg: PropTypes.oneOf([1,2,3,4,5,6,7,8,9,10,11,12]).isRequired,
};

export default CollectorResponses;